import { Component, OnInit } from '@angular/core';
import { PopoverController, ToastController, AnimationController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

export class NewServer {
  serverName: string = '';
  serverLink: string = '';
}

@Component({
  selector: 'app-add-server',
  templateUrl: './add-server.component.html',
  styleUrls: ['./add-server.component.scss'],
})
export class AddServerComponent implements OnInit {
  newServer = new NewServer();
  newServers: NewServer[] = [];
  isSubmitting: boolean = false;

  constructor(
    private popoverController: PopoverController,
    public translate: TranslateService,
    private toastController: ToastController,
    private animationCtrl: AnimationController
  ) {}

  ngOnInit() {
    if (localStorage.getItem('newServers')) {
      try {
        this.newServers = JSON.parse(localStorage.getItem('newServers') || '[]');
      } catch (e) {
        this.newServers = [];
        console.error('Error parsing stored servers:', e);
      }
    }

    // Add input focus animation
    setTimeout(() => {
      const inputEl = document.getElementById('nomServeur');
      if (inputEl) {
        inputEl.focus();
        this.animateElement(inputEl);
      }
    }, 300);
  }

  // Animation helper
  animateElement(element: any) {
    const animation = this.animationCtrl.create()
      .addElement(element)
      .duration(300)
      .iterations(1)
      .fromTo('opacity', '0.5', '1')
      .fromTo('transform', 'translateY(10px)', 'translateY(0)');

    animation.play();
  }

  ajouter() {
    if (!this.acceptServer()) {
      return;
    }

    this.isSubmitting = true;

    try {
      if (localStorage.getItem('newServers')) {
        this.newServers = JSON.parse(localStorage.getItem('newServers') || '[]');
      } else {
        this.newServers = [];
      }

      // Create a new server object with trimmed values
      const newServerObj = {
        serverName: this.newServer.serverName.trim(),
        serverLink: this.newServer.serverLink.trim()
      };

      const isDuplicate = this.newServers.some(server =>
        server.serverLink === newServerObj.serverLink);

      if (isDuplicate) {
        this.showToast(
          this.translate.instant('SIGNIN.SERVER_ALREADY_EXISTS'),
          'warning'
        );
        this.isSubmitting = false;
        return;
      }

      // Add the new server
      this.newServers.push(newServerObj);

      // Save to localStorage
      localStorage.setItem('newServers', JSON.stringify(this.newServers));

      // Show success message
      this.showToast(
        this.translate.instant('SIGNIN.SERVER_ADDED_SUCCESSFULLY'),
        'success'
      );

      // Return the complete new server object to the parent component
      this.popoverController.dismiss({
        newServer: newServerObj
      });

    } catch (error) {
      console.error('Error adding server:', error);
      this.showToast(
        this.translate.instant('SIGNIN.ERROR_ADDING_SERVER'),
        'danger'
      );
      this.isSubmitting = false;
    }
  }

  acceptServer() {
    return this.newServer.serverLink &&
      this.newServer.serverName &&
      this.newServer.serverLink.trim() !== '' &&
      this.newServer.serverName.trim() !== '';
  }

  dismissPopover() {
    this.popoverController.dismiss();
  }

  async showToast(message: string, color: string = 'primary') {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: 'top',
      color: color,
      buttons: [
        {
          icon: 'close',
          role: 'cancel'
        }
      ]
    });

    toast.present();
  }
}
